/**
 * i18n configuration for the Forecaster application.
 *
 * Language resolution order:
 *  1. User-persisted setting (localStorage key: 'userLanguage')
 *  2. Browser language (navigator.language / Accept-Language)
 *  3. Fallback: 'en'
 *
 * Supported languages: 'en' (English), 'fr' (French)
 *
 * French variants (fr-CA, fr-FR, etc.) are mapped to 'fr'.
 * English variants (en-US, en-GB, etc.) are mapped to 'en'.
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import fr from '../locales/fr.json';

import { resolveLanguage } from '@helpers/Utility/locale';

const resources = {
  en: { translation: en },
  fr: { translation: fr },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: resolveLanguage(),
    supportedLngs: ['en', 'fr'],
    fallbackLng: 'en',
    interpolation: {
      // React already escapes values — no need for i18next to double-escape
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    // In development, log missing keys. In production, silently fall back.
    ...(process.env.NODE_ENV === 'development' && {
      saveMissing: true,
      missingKeyHandler: (_lngs: readonly string[], _ns: string, key: string) => {
        console.warn(`[i18n] Missing translation key: "${key}"`);
      },
    }),
  });

export default i18n;
